import { createReducerFromMap } from "@coverme/redux";
import { cloneDeep } from "lodash-es";

function isEmptyOrHasOnlyNulls(object, except = []) {
    if (Object.keys(object).length === 0 && object.constructor === Object) {
        return true;
    }

    for (const prop in object) {
        if (!object.hasOwnProperty(prop)) {
            continue;
        }

        if (except.indexOf(prop) > -1) {
            continue;
        }

        if (object[prop] != null) {
            return false;
        }
    }

    return true;
}

const initialState = {};

function updateExchange(state, data) {
    return data.value;
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    const { value } = action;
    let newState = cloneDeep(state);
    if (value.exchange) {
        if (!isEmptyOrHasOnlyNulls(value.exchange)) {
            newState = updateExchange(newState, { value: value.exchange });
        }
    }

    return newState;
}

function setContinueAfterPiGate(state, action) {
    return {
        ...state,
        isContinuing: action.value,
    };
}

export const exchangeReducer = createReducerFromMap(initialState, {
    UPDATE_EXCHANGE: updateExchange,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
